{
	"summary": {
		"thematic_summaries": [
			{
				"theme": "Internal vs. external facing terms",
				"points": [
					{
						"text": "There's confusion because internally we use 'node' as a technical term, but customers interact with what they perceive as 'blocks', and the block menu can be invoked on single nodes.",
						"comments": [
							"<a href='#comment_id_1' id='comment-source-link' data-comment-id='comment_id_1'>[1]</a>",
							"<a href='#comment_id_2' id='comment-source-link' data-comment-id='comment_id_2'>[2]</a>",
							"<a href='#comment_id_5' id='comment-source-link' data-comment-id='comment_id_5'>[5]</a>"
						]
					},
					{
						"text": "The key distinction is between internal nomenclature (nodes) and customer-facing language (blocks), which needs to be carefully managed.",
						"comments": [
							"<a href='#comment_id_7' id='comment-source-link' data-comment-id='comment_id_7'>[7]</a>"
						]
					},
					{
						"text": "From a customer perspective, blocks represent content like paragraphs and images, and multiple pieces of content become a block of content.",
						"comments": [
							"<a href='#comment_id_6' id='comment-source-link' data-comment-id='comment_id_6'>[6]</a>"
						]
					}
				]
			},
			{
				"theme": "Structural hierarchy and relationships",
				"points": [
					{
						"text": "The proposed hierarchy is Container > Object > Block > Nodes, with questions about whether blocks can be children of other blocks.",
						"comments": [
							"<a href='#comment_id_8' id='comment-source-link' data-comment-id='comment_id_8'>[8]</a>"
						]
					},
					{
						"text": "Blocks can nest within blocks, similar to how nodes can be children of other nodes (like expand in a table).",
						"comments": [
							"<a href='#comment_id_9' id='comment-source-link' data-comment-id='comment_id_9'>[9]</a>"
						]
					},
					{
						"text": "Layout nodes qualify as blocks even though a single column layout is not an object but contains multiple nodes.",
						"comments": [
							"<a href='#comment_id_3' id='comment-source-link' data-comment-id='comment_id_3'>[3]</a>",
							"<a href='#comment_id_4' id='comment-source-link' data-comment-id='comment_id_4'>[4]</a>"
						]
					}
				]
			},
			{
				"theme": "Allowed nesting examples",
				"points": [
					{
						"text": "Confirmed allowed patterns include synced smart blocks, blocks within layout blocks, but not synced blocks within synced blocks.",
						"comments": [
							"<a href='#comment_id_8' id='comment-source-link' data-comment-id='comment_id_8'>[8]</a>"
						]
					}
				]
			},
			{
				"theme": "Specialized blocks",
				"points": [
					{
						"text": "There's agreement that reusable content (\"Snippets\") and \"Synced Blocks\" are specialized types of blocks, not new objects.",
						"comments": [
							"<a href='#comment_id_11' id='comment-source-link' data-comment-id='comment_id_11'>[11]</a>"
						]
					}
				]
			}
		]
	}
}
